import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import MegaphoneIcon from '@atlaskit/icon/core/megaphone';
import Tooltip from '@atlaskit/tooltip';

import { ButtonMenuItem } from '@atlassian/navigation-system/side-nav-items/button-menu-item';

import { useNav4FeedbackCollectorActions } from '@confluence/nav4-feedback';

export const Nav4GiveFeedbackButton = ({ iconOnly = false }: { iconOnly?: boolean }) => {
	const intl = useIntl();
	const { openFeedbackCollector } = useNav4FeedbackCollectorActions();

	return (
		<Tooltip content={intl.formatMessage(i18n.shareFeedbackButtonText)}>
			{iconOnly ? (
				<IconButton
					icon={MegaphoneIcon}
					onClick={openFeedbackCollector}
					label={intl.formatMessage(i18n.shareFeedbackButtonText)}
				/>
			) : (
				<div data-vc="nav4-give-feedback-sidebar-button">
					<ButtonMenuItem
						elemBefore={
							<MegaphoneIcon
								label=""
								color="currentColor"
								testId="nav4-give-feedback-sidebar-button-icon-temp-do-not-use"
							/>
						}
						onClick={openFeedbackCollector}
					>
						{intl.formatMessage(i18n.shareFeedbackButtonText)}
					</ButtonMenuItem>
				</div>
			)}
		</Tooltip>
	);
};

const i18n = defineMessages({
	shareFeedbackButtonText: {
		id: 'page-layout.nav4.feedback-collector.share-feedback-button.text',
		defaultMessage: 'Give feedback on the new navigation',
		description:
			'Text for button to open the feedback collector modal where user can share feedback',
	},
});
